module.exports = __webpack_public_path__ + "media/images/index-download-bg-5bd89e0a1a23f9a40199d29577cd911b.svg";